export enum EReportType {
    AccountStatement,
    AccountStatementPdf,
    Contracts,
    Crops,
    Deliveries,
    CleanedSeeds,
    Samples,
    CoOpStatement,
    CoOpStatementPdf,
    SettlementPrices,
    WaterLetter
}